<template>
  <div class="customer-view-stepper">
    <dass-stepper
      v-bind="args"
      :currentStep="current_step"
      :steps="steps"
      @change="change"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'stepper',  
  components: {},
  emits: ['changeCurrentStep'],
  computed: {
    ...mapGetters('create_protocol', {
      current_step: 'getCurrentStep',      
    }),
    steps: function () {
      const steps = [
        {
          label: this.$t('etapas.itens'),
          name: 'step-items',
        },                 
        {
          label: this.$t('etapas.confirmacao'),
          name: 'step-confirm',
        },
      ]
      return steps
    },
  },  
  methods: {
    change(currentStep) {
      this.$emit('changeCurrentStep', currentStep)
    }
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.customer-view-stepper {
  margin-bottom: var(--space);
}
</style>
